export default __webpack_public_path__ + "static/media/locations.68d3d263.svg";